import { useNavigate } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { SellBoxController } from "./sell-box-controller";
import { SellBoxPage } from "./sell-box-page";

export function SellBoxRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  return (
    <Subtree
      key="sell-box"
      controller={() =>
        new SellBoxController(pick(deps, "client", "authHandler", "storeRepository"), {
          toQueue: () => navigate("/live"),
        })
      }
    >
      <SellBoxPage />
    </Subtree>
  );
}
